module.exports = __webpack_public_path__ + "img/222.45b5960a.png";